import TinySlider from "tiny-slider-react";
import "tiny-slider/dist/tiny-slider.css";

const sliderSettings = {
  items: 3,
  slideBy: "page",
  autoplay: true,
  loop: true,
  controls: true,
  controlsText: ["", "Next"],
  nav: true,
  autoplayButtonOutput: false,
  gutter: 10,
  mouseDrag: true,
  autoplayTimeout: 3000,
  speed: 1000,
  responsive: {
    0: {
      items: 1
    },
    640: {
      items: 2,
    },
    900: {
      items: 3,
    },
    1200: {
      items: 3,
    },
  },
};

const MySlider = ({ SliderData }) => {
  return (
    <TinySlider settings={sliderSettings}>
      {SliderData.map((d, index) => (
        <div className="item p-3 text-white" key={index}>
          <div className="flex flex-col items-center justify-center">
            <img className="w-full h-auto" src={d.Img} alt="img-fluid" />
            <p className="text-center text-dark text-base font-normal m-0 py-1">
              {d.name}
            </p>
            <span className="text-base text-dark font-normal m-0 text-center">
              {d.Roll}
            </span>
          </div>
        </div>

      ))}
    </TinySlider>
  );
};

export default MySlider;
